import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { Fragment, useEffect, useState } from "react";
import { getLoyaltyStorage } from "../../util";
import { AuthenticationState } from "react-aad-msal";
import { LoyaltyAccountStatus } from "../../util/LoyaltyAccountStatus";
import { Image } from "@sitecore-jss/sitecore-jss-react";
import PausedAccountModule from "./PausedAccountModule";

var PausedAccountRewardsPage = function PausedAccountRewardsPage(props) {
  var authenticationState = props.authenticationState;

  var _ref = (props === null || props === void 0 ? void 0 : props.model) || {},
      Copy = _ref.Copy,
      Logo = _ref.Logo,
      PausedAccModule = _ref.PausedAccModule;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      pausedAccount = _useState2[0],
      setPausedAccount = _useState2[1];

  var loyaltyStorage = getLoyaltyStorage();
  var pausedAccountModel = PausedAccModule && PausedAccModule.length >= 1 ? PausedAccModule[0].fields : {};
  useEffect(function () {
    if (authenticationState === AuthenticationState.Authenticated) {
      var _loyaltyStorage$accou;

      if ((loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou = loyaltyStorage.account) === null || _loyaltyStorage$accou === void 0 ? void 0 : _loyaltyStorage$accou.Status) === LoyaltyAccountStatus.Paused) {
        setPausedAccount(true);
      }
    }
  }, []);
  return /*#__PURE__*/React.createElement(Fragment, null, pausedAccount ? /*#__PURE__*/React.createElement("div", {
    className: "rewards-page-paused-account"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rewards-page-paused-account__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rewards-page-paused-account__logo"
  }, /*#__PURE__*/React.createElement(Image, {
    field: Logo
  })), /*#__PURE__*/React.createElement("div", {
    className: "rewards-page-paused-account__module"
  }, /*#__PURE__*/React.createElement(PausedAccountModule, {
    model: pausedAccountModel
  })), /*#__PURE__*/React.createElement("div", {
    className: "rewards-page-paused-account__copy"
  }, /*#__PURE__*/React.createElement("span", null, Copy === null || Copy === void 0 ? void 0 : Copy.value)))) : null);
};

export default PausedAccountRewardsPage;